'use client';

import '@/shared/styles/globals.css';
import { useEffect } from 'react';

import { ErrorSection } from '@shared/components/ErrorSection';

/**
 * 루트까지 올라온 예외의 최종 방어선.
 *
 * `error.tsx` 는 세그먼트 렌더/데이터 페칭 중 던져진 예외만 받는다. 서드파티가
 * 몽키패치한 `history.pushState` 처럼 React 커밋 단계에서 터진 예외는 트리를 통째로
 * 날려 이 경계로 오고, 이 파일이 없으면 Next 기본 문구가 그대로 노출된다.
 *
 * 루트 레이아웃을 대체하므로 html/body 를 직접 그린다 — `ServiceLayout` 처럼
 * 프로바이더에 기대는 컴포넌트는 이 안에서 쓸 수 없다.
 */
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  // 에러 모니터링 도구가 없어 콘솔이 유일한 단서다.
  useEffect(() => {
    console.error('[GlobalError]', error.digest ?? '-', error);
  }, [error]);

  // Next 가 넘기는 reset() 은 루트를 다시 렌더할 뿐이라 깨진 전역 상태(패치된 history 등) 는
  // 그대로 남는다. 여기까지 온 에러는 전체 새로고침이 유일하게 신뢰할 수 있는 복구 수단이다.
  const retry = () => window.location.reload();

  return (
    <html lang="ko">
      <body className="font-pretendard">
        <div className="flex min-h-screen flex-col">
          <ErrorSection onRetry={retry} />
        </div>
      </body>
    </html>
  );
}
